/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Header_Gotostudy2Inputs */

const zh_landing_header_gotostudy2 = /** @type {(inputs: Landing_Header_Gotostudy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进入 StudyOS`)
};

const en_landing_header_gotostudy2 = /** @type {(inputs: Landing_Header_Gotostudy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to StudyOS`)
};

const es_landing_header_gotostudy2 = /** @type {(inputs: Landing_Header_Gotostudy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a StudyOS`)
};

/**
* | output |
* | --- |
* | "Go to StudyOS" |
*
* @param {Landing_Header_Gotostudy2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_header_gotostudy2 = /** @type {((inputs?: Landing_Header_Gotostudy2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Header_Gotostudy2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_header_gotostudy2(inputs)
	if (locale === "en") return en_landing_header_gotostudy2(inputs)
	return es_landing_header_gotostudy2(inputs)
});
export { landing_header_gotostudy2 as "landing_header_goToStudy" }